import { BYTES_PER_MEGABYTE } from 'common/constants/bytes';

export const DEFAULT_MERCHANT_NAME = 'Merchant name not provided';

export const MAX_FILE_SIZE_BYTES = 10 * BYTES_PER_MEGABYTE;
